import styled from 'styled-components';

export const NoWrapText = styled.p`
  white-space: nowrap;
`;
